import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CondicionIngreso {
  constructor (args = {}) {
    Object.keys(args)
      .forEach(c => { this[c] = args[c] })
  }

  static getCalificacionesCondicional (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`listado_indice_condicional_de_un_cereal?r=` +
      `{"clave":{"cereal": "${claveCereal}"}, "orden":["d:indice"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static getCalificacionesRechazo (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`listado_indice_rechazo_de_un_cereal?r=` +
      `{"clave":{"cereal": "${claveCereal}"}, "orden":["d:indice"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default CondicionIngreso
